import { v4 as uuidv4 } from 'uuid';
// import { AvailableTimeMap } from '../../store/coach/types';

export const getTimeSlots = (startTime: number, length: number, date: Date) =>
    Array.from(Array(length)).map((_, index) => ({
        date,
        time: `${index + startTime}:00-${index + startTime + 1}:00`,
        id: uuidv4(),
    }));

export const isWeekend = (date: Date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
};
